import { t } from 'i18next'

import type { TGetSimulacoesRelacionadas } from '@/features/simulador/brasil/types/simulacao.type'

type TConfirmacaoSelecaoValidador = {
  simulacaoPrincipal: TGetSimulacoesRelacionadas['simulacaoPrincipal']
  simulacoesSelecionadas: Array<TGetSimulacoesRelacionadas['simulacaoPrincipal']>
}

export class ConfirmacaoSelecaoValidador {
  private readonly simulacoes: Array<TGetSimulacoesRelacionadas['simulacaoPrincipal']>
  private readonly simulacaoPrincipal: TGetSimulacoesRelacionadas['simulacaoPrincipal']

  constructor({ simulacaoPrincipal, simulacoesSelecionadas: simulacoes }: TConfirmacaoSelecaoValidador) {
    this.simulacaoPrincipal = simulacaoPrincipal
    this.simulacoes = simulacoes
  }

  private simulacaoPrincipalpossuiParcelaVencida(): boolean {
    return this.simulacaoPrincipal.possuiParcelaVencida
  }

  private simulacaoPrincipalPossuiAcessorioZeradoSemUnidade(): boolean {
    const possuiUnidade = this.simulacoes.some((s) => s.tipoDoProduto === 'Unidade')
    const acessorioZerado =
      this.simulacaoPrincipal.tipoDoProduto === 'Acessorio' && this.simulacaoPrincipal.valorTotalSimulado === 0
    return acessorioZerado && !possuiUnidade
  }

  validate(): string | null {
    if (this.simulacaoPrincipalpossuiParcelaVencida()) {
      return t('proposta:selecao_produto.erros.parcelas_vencidas')
    }

    if (this.simulacaoPrincipalPossuiAcessorioZeradoSemUnidade()) {
      return t('proposta:selecao_produto.erros.acessorio_zerado')
    }

    return null
  }
}
